// Belt-and-suspenders alongside the CSS `pointer-events: none` rule on
// `.pdp-immersive-gallery .product__modal-opener`: intercept in the CAPTURE
// phase at the document level (fires before Dawn's own listeners, which are
// wherever they are in the tree) so tapping the full-screen photo never opens
// Dawn's built-in zoom modal. Real devices showed the CSS-only rule wasn't
// enough to stop it, so this stops the click before it can reach Dawn's
// handler at all. Only 'click' is intercepted (not touchstart/touchmove), so
// native horizontal swipe-scrolling between photos is untouched.
document.addEventListener(
  'click',
  function (e) {
    var opener = e.target.closest && e.target.closest('.pdp-immersive-gallery .product__modal-opener');
    if (opener) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) {
        e.stopImmediatePropagation();
      }
    }
  },
  true
);

// Mobile immersive product pages hide Dawn's real header (and with it the
// real #cart-icon-bubble, which Dawn's own cart-notification.js /
// cart-drawer.js keep in sync automatically after every add-to-cart) via
// `body.pdp-immersive .section-header { display: none !important; }` in
// pdp-immersive-gallery.css, scoped to mobile viewports only (<=749px). The
// cart icon shown in its place here (`.pdp-immersive-cart`, rendered by
// snippets/product-media-gallery.liquid) is a separate, static duplicate:
// its count badge was previously only ever set once, server-side, from
// cart.item_count at initial page load, so it went stale as soon as the
// customer added anything to the cart (desktop was unaffected since the
// hiding media query is mobile-only and the real header stayed visible and
// working there). This subscribes to the same PUB_SUB_EVENTS.cartUpdate
// event Dawn's own cart widgets rely on (published by product-form.js after
// every successful add-to-cart, regardless of cart_type) and keeps this
// badge in sync too, independently of whether the real header is visible.
// constants.js / pubsub.js are loaded (deferred) earlier in layout/theme.liquid
// than this script, so `subscribe` and `PUB_SUB_EVENTS` are already defined
// by the time this top-level code runs.
if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
    var countEls = document.querySelectorAll('[data-pdp-immersive-cart-count]');
    if (!countEls.length) return;

    function applyCount(count) {
      var n = parseInt(count, 10);
      if (isNaN(n)) return;
      countEls.forEach(function (el) {
        el.textContent = n;
        el.hidden = n <= 0;
      });
    }

    var sectionHtml =
      event && event.cartData && event.cartData.sections && event.cartData.sections['cart-icon-bubble'];

    if (sectionHtml) {
      try {
        var doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
        var bubble = doc.querySelector('.cart-count-bubble span[aria-hidden="true"]');
        if (bubble) {
          applyCount(bubble.textContent);
          return;
        }
        // Section rendered with no .cart-count-bubble at all means the cart
        // just became empty (cart-icon-bubble.liquid only renders the
        // bubble when cart != empty).
        applyCount(0);
        return;
      } catch (err) {
        // Fall through to the /cart.js fallback below.
      }
    }

    // Fallback in case the cart-icon-bubble section wasn't part of this
    // particular response: ask Shopify directly for the current cart.
    fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        applyCount(cart.item_count);
      })
      .catch(function () {});
  });

  // "Added to cart" bounce toast for the mobile immersive product page —
  // see the comment above .pdp-immersive-cart-toast in
  // pdp-immersive-gallery.css for why this is a self-contained replacement
  // rather than an attempt to reuse Dawn's real (but unreachable-on-mobile)
  // <cart-notification> popup. Guarded to mobile widths only, matching the
  // CSS breakpoint (<=749px) — on desktop the real popup already works
  // correctly (see the cart-icon-bubble fix above for why: the CSS that
  // hides Dawn's header is itself mobile-only), so this must not also fire
  // there and show a second, redundant confirmation.
  subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
    if (!window.matchMedia('(max-width: 749px)').matches) return;

    var toast = document.querySelector('.pdp-immersive-cart-toast');
    if (!toast) return;

    var cartData = event && event.cartData;
    var sections = cartData && cartData.sections;
    if (!sections) return;

    var productWrap = toast.querySelector('[data-pdp-immersive-cart-toast-product]');
    var buttonEl = toast.querySelector('[data-pdp-immersive-cart-toast-button]');

    // Reuse Dawn's own cart-notification-product section markup (same
    // Section Rendering API response Dawn's real popup uses) so product
    // name/image formatting matches the rest of the theme. That section
    // renders ALL cart line items, each in its own
    // #cart-notification-product-{key} wrapper — pick out just the one
    // that was actually just added, exactly like cart-notification.js does.
    if (productWrap && sections['cart-notification-product'] && cartData.key) {
      try {
        var productDoc = new DOMParser().parseFromString(sections['cart-notification-product'], 'text/html');
        var row = productDoc.getElementById('cart-notification-product-' + cartData.key);
        if (row) {
          productWrap.innerHTML = '';
          productWrap.appendChild(row.cloneNode(true));
        }
      } catch (err) {
        // Leave whatever was there from a previous add, if any.
      }
    }

    if (buttonEl && sections['cart-notification-button']) {
      try {
        var buttonDoc = new DOMParser().parseFromString(sections['cart-notification-button'], 'text/html');
        var label = buttonDoc.body.textContent.trim();
        if (label) buttonEl.textContent = label;
      } catch (err) {
        // Leave the previous label.
      }
    }

    clearTimeout(toast._pdpImmersiveHideTimer);
    toast.classList.add('active');
    toast._pdpImmersiveHideTimer = setTimeout(function () {
      toast.classList.remove('active');
    }, 3500);
  });
}

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-pdp-immersive-back]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (window.history.length > 1) {
        window.history.back();
      } else {
        window.location.href = '/';
      }
    });
  });

  document.querySelectorAll('[data-pdp-immersive-cart-toast-close]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var toast = btn.closest('.pdp-immersive-cart-toast');
      if (!toast) return;
      clearTimeout(toast._pdpImmersiveHideTimer);
      toast.classList.remove('active');
    });
  });

  document.querySelectorAll('[data-pdp-immersive-share]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var title = btn.getAttribute('data-share-title') || document.title;
      var url = btn.getAttribute('data-share-url') || window.location.href;

      if (navigator.share) {
        navigator.share({ title: title, url: url }).catch(function () {});
        return;
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(function () {
          btn.setAttribute('data-copied', 'true');
          setTimeout(function () {
            btn.removeAttribute('data-copied');
          }, 1500);
        });
      }
    });
  });

  // As the customer swipes through the full-screen gallery, show a small
  // floating label with the color name of whichever photo is currently in
  // view (when that photo belongs to a specific color variant), AND
  // highlight the matching real color swatch button so it visually looks
  // "selected" for that color. Both are DELIBERATELY read-only: this code
  // only ever reads which slide is visible and (a) writes text into the
  // badge, (b) toggles a CSS class on the matching swatch <label>. It never
  // checks a swatch radio button's `checked` property and never fires a
  // variant 'change' event. That's intentional — Dawn's own variant-change
  // handling (assets/product-info.js) does a network fetch and then
  // re-sorts the gallery's <li> elements (prepending the newly selected
  // variant's photo to the front of the list) and force-scrolls the
  // gallery to it. Wiring that up to fire on every swipe would fight the
  // customer's own swipe, reorder photos out from under their thumb, and
  // spam network requests. So swiping only ever updates the badge text and
  // the swatch's visual highlight; actually switching color/variant (price,
  // SKU, add-to-cart target) is still a deliberate tap on the real swatch.
  document.querySelectorAll('.pdp-immersive-gallery').forEach(function (gallery) {
    var mapScript = gallery.querySelector('[data-pdp-immersive-color-map]');
    var badge = gallery.querySelector('[data-pdp-immersive-color-badge]');
    var list = gallery.querySelector('.product__media-list');
    if (!mapScript || !badge || !list) return;

    var colorByMediaId = {};
    try {
      JSON.parse(mapScript.textContent).forEach(function (entry) {
        colorByMediaId[String(entry.mediaId)] = entry.color;
      });
    } catch (err) {
      return;
    }

    var slides = Array.from(list.querySelectorAll('[data-pdp-media-numeric-id]'));
    if (!slides.length) return;

    // The real color swatches live in the variant picker (product-info),
    // entirely outside .pdp-immersive-gallery, rendered by
    // snippets/product-variant-options.liquid as
    // `<label class="pill-color-swatch" title="{{ value.name }}">`. The
    // `title` is the exact raw option value (e.g. "BROWN1764"), the same
    // raw string captured as `color` in the media-id -> color map above
    // (both come from `value`/`pdp_variant.options[...]`), so matching by
    // exact title text reliably finds the right swatch without needing a
    // shared id. Gathered once — the swatch list doesn't change as the
    // customer swipes, only as Dawn's own AJAX variant swap replaces
    // product-info (see swatchLabels() re-query below for that case).
    function swatchLabels() {
      return Array.from(document.querySelectorAll('label.pill-color-swatch'));
    }

    var highlightedLabel = null;

    function highlightSwatch(color) {
      if (highlightedLabel) {
        highlightedLabel.classList.remove('pdp-immersive-swipe-active');
        highlightedLabel = null;
      }
      if (!color) return;
      var match = swatchLabels().find(function (label) {
        return label.title === color;
      });
      if (match) {
        match.classList.add('pdp-immersive-swipe-active');
        highlightedLabel = match;
      }
    }

    var currentColor = null;

    function showColor(color) {
      if (color === currentColor) return;
      currentColor = color;
      if (color) {
        badge.textContent = color;
        badge.hidden = false;
      } else {
        badge.hidden = true;
      }
      highlightSwatch(color);
    }

    var observer = new IntersectionObserver(
      function (entries) {
        var best = null;
        entries.forEach(function (entry) {
          if (!best || entry.intersectionRatio > best.intersectionRatio) {
            best = entry;
          }
        });
        if (best && best.intersectionRatio > 0.6) {
          var mediaId = best.target.getAttribute('data-pdp-media-numeric-id');
          showColor(colorByMediaId[mediaId] || null);
        }
      },
      { root: list, threshold: [0, 0.6, 1] }
    );

    slides.forEach(function (slide) {
      observer.observe(slide);
    });
  });

  // Dawn's own SliderComponent (assets/global.js) recomputes and overwrites
  // the "total" number in the "1 / N" counter on every scroll:
  //   slidesPerPage = Math.floor((slider.clientWidth - firstItem.offsetLeft) / itemOffset)
  //   totalPages = sliderItemsToShow.length - slidesPerPage + 1
  // That formula is built for a "peek" carousel that can show MULTIPLE
  // items per page, and only stays correct when slidesPerPage resolves to
  // 1. Our full-bleed immersive redesign always shows exactly one
  // full-width photo at a time, so slidesPerPage should always be 1 — but
  // sub-pixel layout rounding (fractional viewport widths, browser-specific
  // offsetLeft rounding) can occasionally round that division down to 0,
  // which inflates totalPages by one (e.g. showing "3 / 4" for a product
  // that only has 3 real photos, and the swipe understandably appearing to
  // "stop early" at the true last photo). Rather than patch Dawn's shared
  // global.js (used by every other slider on the site) or race against its
  // own script/upgrade timing, keep the total pinned to the real,
  // server-rendered count.
  //
  // IMPORTANT: the "correct" value must come from a static
  // data-correct-total="{{ render_media_count }}" attribute rendered by
  // Liquid (snippets/product-media-gallery.liquid), NOT from this element's
  // live textContent. slider-component is a custom element, and custom
  // element constructors run as soon as the browser's HTML parser reaches
  // the tag — which can happen well before DOMContentLoaded fires. That
  // means Dawn's SliderComponent can already have overwritten the counter
  // text by the time this DOMContentLoaded handler runs, so capturing
  // "whatever text is there right now" is unreliable — it can just as
  // easily lock in the WRONG number as the right one. The data attribute is
  // never touched by Dawn's script, so it's a safe source of truth
  // regardless of timing. Every occurrence is resynced immediately (in case
  // it was already corrupted before this ran) and then kept in sync via
  // MutationObserver for every later overwrite (scroll, resize, etc.). The
  // "current" page number is left untouched — that part of Dawn's math
  // (scrollLeft / itemOffset) is unaffected by this bug.
  document.querySelectorAll('.pdp-immersive-gallery .slider-counter--total').forEach(function (totalEl) {
    var correctTotal = totalEl.getAttribute('data-correct-total') || totalEl.textContent;
    var resync = function () {
      if (totalEl.textContent !== correctTotal) {
        totalEl.textContent = correctTotal;
      }
    };
    resync();
    new MutationObserver(resync).observe(totalEl, { childList: true, characterData: true, subtree: true });
  });
});

